import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.isAnalysesAvailable
    ? _c(
        VBadge,
        {
          attrs: {
            color: "error",
            "offset-x": "20",
            "offset-y": "20",
            content: _setup.analysesCountInCartContent,
            value: _setup.analysesCountInCartContent,
          },
        },
        [
          _c(
            VBtn,
            {
              attrs: {
                icon: "",
                "data-qa": "cart-icon-header",
                href: _setup.analysesPath,
                small: _setup.isMobile,
              },
            },
            [_c(VIcon, [_vm._v("\n      ui-icon-cart\n    ")])],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }